<template>
  <div>
    <InputMoney
        v-model="value_cash"
        label="Preço"
        name="value_cash"
        :errors="errors"
    />
    <InputMoney
        v-model="value_old"
        label="Preço Promocional"
        name="value_old"
        :errors="errors"
    />

    <InputMoney
        v-model="spare"
        label="Economize"
        name="spare"
        :errors="errors"
    />
  </div>
</template>

<script>
import InputMoney from "../inputs/InputMoney.vue";

export default {
  name: "DePor",
  components: {InputMoney},
  data() {
    return {
      errors: [],
      value_cash: null,
      value_old: null,
      spare: null,
    }
  },

  watch: {
    value_cash() {
      this.calculate();
    },
    value_old() {
      this.calculate();
    },
  },

  methods: {
    calculate() {
      const valueCash = this.parseToFloat(this.value_cash) * 100;
      const valueOld = this.parseToFloat(this.value_old) * 100;

      if (valueCash <= 0 || valueOld <= 0) {
        this.spare = this.cleanValue(0)
        return
      }

      const result = (valueCash - valueOld) / 100;
      this.spare = this.cleanValue(result)
    },

    cleanValue: function (value) {
      if (value) {
        value = value.toString().match(/^-?\d+(?:\.\d{0,2})?/)[0];
        value = (/\.[0-9]{1}$/g.test(value)) ? value + '0' : value;
        value = (/^\d+$/.test(value)) ? value + '.00' : value;
        value = value.toString().replace('.', ',');
      }
      return value;
    },

    parseToFloat(value) {
      if (value) {
        return parseFloat(value.replace(/\./g, '').replace(',', '.'));
      }
    },
  }
}
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/carrefour/rules/DePor.vue